import React from 'react';
import { S } from './Main.styles';

export const Main: React.FC<React.PropsWithChildren> = (props) => {
  return <S.MainContainer>{props.children}</S.MainContainer>;
};
